import './Note.css'

const Note = ({onClick, image, title, link, authors, description, idea, available}) => {
    return (
        <div className={available ? 'note-container' : 'note-container not-available-note'}>
            <img className={available ? 'note-image' : 'note-image not-available-image'} src={image} alt='paper-concept-presentation'></img>
            <div className='note-text-content'>
                <div className='note-title-date-container'>
                    <div className='note-title-date-container'>
                        <span className='note-title'>{title}</span>
                    </div>
                    <span className='note-paper-authors'>{authors}</span>
                </div>
                <div>
                    <span className='note-description'>{description}</span><br/>
                    <span className='note-paper-idea'>{idea}</span><br/>
                    <div className='note-paper-link-container'>
                        🔗 
                        <span className='note-paper-link' onClick={() => window.open(link, '_blank')}>Link to Paper</span>
                    </div>
                </div>
                <span 
                    className={available ? 'note-link' : 'not-available-link'} 
                    onClick={onClick}
                >
                    {available ? 'Read Notes' : 'Coming soon 🔥'}
                </span>
            </div>
        </div>
    )
}

export default Note